import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgLightningIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M15 6H8.4L10 1.3c.3-1-.9-1.8-1.7-1l-8 8C-.3 8.9.1 10 1 10h6.6L6 14.7c-.3 1 .9 1.8 1.7 1l8-8c.6-.6.2-1.7-.7-1.7z"
    />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgLightningStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgLightningIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const LightningIcon: any = SvgLightningStyle;
export default LightningIcon;
